import { Link } from "@inertiajs/react";

export default function ForgotPassword() {
    return (
        <>
            <header className="flex flex-wrap md:justify-start md:flex-nowrap z-50 bg-white border-b border-gray-200">
                <div className="max-w-[85rem] flex justify-center basis-full items-center w-full mx-auto py-3 px-4 sm:px-6 lg:px-8">
                    <a
                        className="flex-none rounded-md text-xl inline-block font-semibold focus:outline-hidden focus:opacity-80"
                        href="/"
                        aria-label="nitnot.store"
                    >
                        nitnot.store
                    </a>
                </div>
            </header>

            <main className="min-h-[calc(100vh-160px)] bg-white pb-20">
                <div className="mx-auto w-full max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-16">
                    <div className="mx-auto max-w-2xl rounded-3xl border border-fuchsia-300/30 bg-[#120726]/65 p-7 shadow-[0_0_40px_rgba(168,85,247,0.25)] backdrop-blur-md sm:p-10">
                        <div className="space-y-3 text-center">
                            <div className="inline-flex rounded-full border border-fuchsia-300/30 bg-fuchsia-500/10 px-3 py-1 text-xs font-medium uppercase tracking-[0.25em] text-fuchsia-200/75">
                                Reset Kata Sandi
                            </div>
                            <h1 className="text-2xl font-semibold text-fuchsia-100 sm:text-3xl">
                                Lupa password?
                            </h1>
                            <p className="text-sm leading-6 text-fuchsia-200/75 sm:text-base">
                                Website ini tidak menggunakan link reset password melalui email. Reset password dilakukan menggunakan password sementara yang dibuat oleh admin.
                            </p>
                        </div>

                        <div className="mt-8 grid gap-4 sm:grid-cols-3">
                            <div className="rounded-2xl border border-fuchsia-300/20 bg-[#1b0b35]/85 p-4">
                                <div className="text-xs font-medium uppercase tracking-wide text-fuchsia-200/60">
                                    Langkah 1
                                </div>
                                <div className="mt-2 text-sm font-medium text-fuchsia-100">
                                    Hubungi Admin
                                </div>
                                <p className="mt-2 text-sm leading-6 text-fuchsia-200/70">
                                    Minta admin untuk mereset password akun Anda melalui panel member.
                                </p>
                            </div>

                            <div className="rounded-2xl border border-fuchsia-300/20 bg-[#1b0b35]/85 p-4">
                                <div className="text-xs font-medium uppercase tracking-wide text-fuchsia-200/60">
                                    Langkah 2
                                </div>
                                <div className="mt-2 text-sm font-medium text-fuchsia-100">
                                    Dapatkan Password Sementara
                                </div>
                                <p className="mt-2 text-sm leading-6 text-fuchsia-200/70">
                                    Admin akan membuat password sementara dan memberikannya kepada Anda secara aman.
                                </p>
                            </div>

                            <div className="rounded-2xl border border-fuchsia-300/20 bg-[#1b0b35]/85 p-4">
                                <div className="text-xs font-medium uppercase tracking-wide text-fuchsia-200/60">
                                    Langkah 3
                                </div>
                                <div className="mt-2 text-sm font-medium text-fuchsia-100">
                                    Ganti Password
                                </div>
                                <p className="mt-2 text-sm leading-6 text-fuchsia-200/70">
                                    Login menggunakan password sementara lalu segera buat password baru.
                                </p>
                            </div>
                        </div>

                        <div className="mt-8 rounded-2xl border border-amber-300/25 bg-amber-500/10 p-5 text-sm leading-6 text-amber-100">
                            Siapkan data akun Anda sebelum menghubungi admin:
                            <ul className="mt-3 list-disc space-y-1 pl-5 text-amber-100/85">
                                <li>Alamat email yang digunakan untuk login</li>
                                <li>Kode member, jika Anda memilikinya</li>
                                <li>Nomor telepon yang terdaftar di profil</li>
                            </ul>
                        </div>

                        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
                            <Link
                                href="/login"
                                className="inline-flex items-center justify-center rounded-lg border border-fuchsia-300/35 bg-[#1b0b35]/80 px-4 py-3 text-sm font-medium text-fuchsia-100 shadow-[0_0_20px_rgba(168,85,247,0.2)] hover:bg-[#231046] focus:outline-hidden focus:ring-2 focus:ring-fuchsia-400/50"
                            >
                                Kembali ke Login
                            </Link>
                            <Link
                                href="/sign-up"
                                className="inline-flex items-center justify-center rounded-lg border border-fuchsia-400/50 bg-gradient-to-r from-violet-600 to-fuchsia-600 px-4 py-3 text-sm font-medium text-white shadow-[0_0_24px_rgba(217,70,239,0.45)] hover:from-violet-500 hover:to-fuchsia-500 focus:outline-hidden focus:ring-2 focus:ring-fuchsia-400/60"
                            >
                                Buat Akun Baru
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
